<template>
<div>
	<div v-if="!numImported">
		<h3>Instructions</h3>

		<h4>Fields:</h4>

		<ul>
			<li>Name</li>
			<li>Entity Type (Company/Person)</li>
			<li>Relationship (Customer/Supplier/Blank)</li>
			<li>Company Type (leave blank if person)</li>
			<li>Position (leave blank if company)</li>
			<li>Phone</li>
			<li>Email</li>
			<li>Suite #</li>
			<li>Address</li>
			<li>City</li>
			<li>Province/State</li>
			<li>Postal Code/Zip</li>
		</ul>

		<p><a href="#" v-on:click.prevent="sampleCSV">Download a CSV Template</a></p>

		<p><strong>Example:</strong></p>

		<div style="overflow-x: auto;">
			<table class="spreadsheet-table mb-3">
				<tr>
					<th></th>
					<th>A</th>
					<th>C</th>
					<th>D</th>
					<th>E</th>
					<th>F</th>
					<th>G</th>
					<th>H</th>
					<th>I</th>
					<th>J</th>
					<th>K</th>
					<th>L</th>
					<th>M</th>
				</tr>
				<tr>
					<th>1</th>
					<td>Name</td>
					<td>Entity Type (Company/Person)</td>
					<td>Relationship (Customer/Supplier/Blank)</td>
					<td>Company Type (leave blank if person)</td>
					<td>Position (leave blank if company)</td>
					<td>Phone</td>
					<td>Email</td>
					<td>Suite #</td>
					<td>Address</td>
					<td>City</td>
					<td>Province/State</td>
					<td>Postal Code/Zip</td>
				</tr>
				<tr>
					<th>2</th>
					<td>Bob Jones</td>
					<td>Person</td>
					<td>Customer</td>
					<td></td>
					<td>President</td>
					<td>519-222-3333</td>
					<td>bob@widgetsrus.com</td>
					<td></td>
					<td>123 Factory St</td>
					<td>London</td>
					<td>ON</td>
					<td>L9G 3Y1</td>
				</tr>
				<tr>
					<th>3</th>
					<td>Widgets R Us Ltd.</td>
					<td>Company</td>
					<td>Customer</td>
					<td>Manufacturer</td>
					<td></td>
					<td>519-333-4444</td>
					<td>sales@widgetsrus.com</td>
					<td></td>
					<td>123 Factory St</td>
					<td>London</td>
					<td>ON</td>
					<td>L9G 3Y1</td>
				</tr>
				<tr>
					<th>4</th>
					<td>Pipe Supplies Inc.</td>
					<td>Company</td>
					<td>Supplier</td>
					<td>Pipe Distributor</td>
					<td></td>
					<td>705-111-6666</td>
					<td>info@pipesupplies.com</td>
					<td></td>
					<td>567 Makit Ave</td>
					<td>Hamilton</td>
					<td>ON</td>
					<td>G7S 1Y1</td>
				</tr>
			</table>
		</div>

		<input type="file" class="form-control mb-2 mt-2" v-on:change="uploadContacts">
	</div>
	<div v-else>
		<div class="text-center alert alert-success">
			<i class="fa fa-3x fa-check-circle"></i>

			<h2>{{ numImported }} contacts imported!</h2>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "ContactsImport",
	components: {
		Field
	},
	data() {
		return {
			file: null,
			numImported: false
		}
	},
	methods: {
		sampleCSV() {
			this.exportToCSV("contacts_import_template.csv",[
				[
					"Name",
					"Entity Type (Company/Person)",
					"Relationship (Customer/Supplier/Blank)",
					"Company Type (leave blank if person)",
					"Position (leave blank if company)",
					"Phone",
					"Email",
					"Suite #",
					"Address",
					"City",
					"Province",
					"Postal Code",
				]
			])
		},
		uploadContacts(evt) {
			let vm = this

			if (evt.target.files.length > 0)
				this.file = evt.target.files[0]

			let f = this.file;

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, resource, numFields

						numFields = 12

						//check appropriate number of fields per row
						csvObj.forEach(row => {
							if (row.length != numFields)
								fileValid = false
						})

						recordsPayload = csvObj.filter((row,index) => index > 0).map(row => {
							let is_company = 0
							if (row[1].toLowerCase() == "company")
								is_company = 1

							let is_customer = 0
							if (row[2].toLowerCase() == "customer")
								is_customer = 1

							let is_supplier = 0
							if (row[2].toLowerCase() == "supplier")
								is_supplier = 1

							return {
								name: row[0],
								is_company,
								is_customer,
								is_supplier,
								company_type: row[3],
								position: row[4],
								phone: row[5],
								email: row[6],
								suite: row[7],
								address: row[8],
								city: row[9],
								province: row[10],
								postal_code: row[11]
							}
						})
						
						if (fileValid) {
							vm.spinner(true)

							vm.postData("Contact/save-batch",{records: JSON.stringify(recordsPayload)}).then(response => {
								vm.alertSaved(response.data.records_saved+" contacts imported!")
								vm.spinner(false)
								vm.numImported = response.data.records_saved
							})
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row.")
						
					};
				})(f);

				reader.readAsText(f);
			}
		},
	},
	created() {

	}
}
</script>

<style scoped>
	.list-group-item-action {
		cursor: pointer;
	}
</style>